import tryConversionToE164Format from './convert_to_E164';

const CALENDLY_BASE_URL = 'https://calendly.com/daniel-carequilt/care-plan-call-with-daniel';

const buildBlakeCalendlyLink = ({user, clientData, eventTypeSlug} = {}) => {
  const userRn = user?.userRn;
  const userEmail = user?.email;
  const userFirstName = user?.firstName;
  const userLastName = user?.lastName;
  const userContacts = clientData?.clientDetail?.relationships?.[userRn]?.contacts ?? [];
  const normalizedEventTypeSlug = `${eventTypeSlug ?? ''}`.trim().replace(/^\/+/, '');
  const calendlyUrl = normalizedEventTypeSlug ? `${CALENDLY_BASE_URL}/${normalizedEventTypeSlug}` : CALENDLY_BASE_URL;

  const rawUserPhoneNumber = userContacts.find((contactObj) => contactObj.type === 'Phone')?.detail ?? null;
  let convertedUserPhoneNumber = null;
  if (rawUserPhoneNumber) {
    convertedUserPhoneNumber = tryConversionToE164Format(rawUserPhoneNumber);
  }

  const queryParams = {};
  if (userRn) {
    queryParams.utm_term = userRn;
  }

  if (convertedUserPhoneNumber) {
    queryParams.location = convertedUserPhoneNumber;
  }

  if (userEmail) {
    queryParams.email = userEmail;
    queryParams.utm_source = userEmail;
  }

  if (userFirstName || userLastName) {
    queryParams.name = `${userFirstName ?? ''} ${userLastName ?? ''}`.trim();
  }

  const queryString = new URLSearchParams(queryParams).toString();
  return queryString ? `${calendlyUrl}?${queryString}` : calendlyUrl;
};

export default buildBlakeCalendlyLink;
